export default "__VITE_ASSET__DvyF7fz0__"